import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiDownload } from 'react-icons/fi';
import { services } from '../utils/servicesData';

export default function Services() {
  return (
    <div style={{ paddingTop: 74 }}>
      {/* Hero */}
      <section style={{ background: 'linear-gradient(135deg, #060F1E 0%, var(--navy) 100%)', padding: '5.5rem 0 4rem', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -100, right: -100, width: 500, height: 500, borderRadius: '50%', background: 'rgba(201,168,76,0.05)' }} />
        <div className="container">
          <span className="label" style={{ marginBottom: '1rem', display: 'inline-flex' }}>What We Offer</span>
          <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: 'clamp(2.2rem, 4vw, 3.2rem)', color: 'white', marginBottom: '1.25rem', maxWidth: 600, lineHeight: 1.15 }}>
            End-to-End Food Safety & Regulatory Services
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '1.05rem', maxWidth: 560, lineHeight: 1.75 }}>
            From initial gap assessment through certification and beyond — we provide every service your food business needs to achieve and maintain the highest safety and compliance standards.
          </p>
        </div>
      </section>

{/* BROCHURE CTA */}
            <section style={{ background:'white', padding:'2.5rem 0 3rem', borderBottom:'1px solid #E5E7EB' }}>
              <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 1rem' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '1.25rem',
                  flexWrap: 'wrap',
                  background: '#0B2545',
                  border: '1px solid rgba(255,255,255,0.12)',
                  borderLeft: '4px solid #C9A84C',
                  borderRadius: '18px',
                  padding: '1.5rem 2rem',
                  boxShadow: '0 14px 36px rgba(11, 37, 69, 0.2)'
                }}>
                  <p style={{ margin: 0, fontSize: '1rem', color: 'white', fontFamily: 'Outfit,sans-serif', lineHeight: 1.6 }}>
                    Want to know more about our services?
                  </p>
                  <a href="/SQS-Brochure.pdf" download="SQS-Brochure.pdf" style={{ display:'inline-flex', alignItems:'center', gap:'0.5rem', background:'#C9A84C', color:'#0B2545', padding:'0.75rem 1.5rem', borderRadius:'50px', fontWeight:600, fontSize:'0.92rem', fontFamily:'Outfit,sans-serif', textDecoration:'none', whiteSpace:'nowrap' }}>
                    <FiDownload />
                    Download Our Brochure
                  </a>
                </div>
              </div>
            </section>

      {/* Services Grid */}
      <section className="section-pad" style={{ background: 'var(--off-white)' }}>
        <div className="container">
          <div className="grid-3">
            {services.map((sv, i) => (
              <motion.div key={sv.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07, duration: 0.5 }}>
                <Link to={`/services/${sv.id}`} style={{ display: 'flex', flexDirection: 'column', background: 'white', borderRadius: '20px', overflow: 'hidden', boxShadow: 'var(--shadow-sm)', border: '1px solid var(--gray-100)', transition: 'all 0.3s', textDecoration: 'none', height: '100%' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = 'var(--shadow-lg)'; e.currentTarget.style.borderColor = '#C9A84C'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; e.currentTarget.style.borderColor = 'var(--gray-100)'; }}>
                  {/* Image */}
                  <div style={{ height: 190, overflow: 'hidden', position: 'relative' }}>
                    <img src={sv.heroImg} alt={sv.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
                      onMouseEnter={e => e.target.style.transform = 'scale(1.06)'}
                      onMouseLeave={e => e.target.style.transform = 'scale(1)'} />
                    <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(11,37,69,0.5) 0%, transparent 60%)' }} />
                    <div style={{ position: 'absolute', top: '1rem', left: '1rem', width: 44, height: 44, background: 'white', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', boxShadow: '0 2px 8px rgba(0,0,0,0.12)' }}>{sv.icon}</div>
                  </div>
                  {/* Content */}
                  <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <h3 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.05rem', color: 'var(--navy)', marginBottom: '0.5rem', lineHeight: 1.3 }}>{sv.title}</h3>
                    <p style={{ fontSize: '0.83rem', color: 'var(--gray-500)', lineHeight: 1.65, flex: 1, marginBottom: '1.25rem' }}>{sv.tagline}</p>
                    <span style={{ fontSize: '0.82rem', color: 'var(--gold)', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                      Read More <FiArrowRight style={{ fontSize: '0.78rem' }} />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: 'var(--navy)', padding: '5rem 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <span className="label" style={{ marginBottom: '1rem', display: 'inline-flex', justifyContent: 'center' }}>Ready to Start?</span>
          <h2 style={{ fontFamily: 'Fraunces, serif', fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', color: 'white', marginBottom: '1.25rem' }}>
            Not Sure Which Service You Need?
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 500, margin: '0 auto 2.5rem', lineHeight: 1.75, fontSize: '1rem' }}>
            Book a free 30-minute consultation and our experts will assess your needs and recommend the right solutions.
          </p>
          <Link to="/book-service" className="btn btn-gold" style={{ fontSize: '0.95rem', padding: '0.9rem 2.25rem' }}>
            Book a Free Consultation <FiArrowRight />
          </Link>
        </div>
      </section>
    </div>
  );
}
